import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/layouts/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Contacts from "@/pages/Contacts";
import Leads from "@/pages/Leads";
import Deals from "@/pages/Deals";
import Tickets from "@/pages/Tickets";
import Invoices from "@/pages/Invoices";
import Staff from "@/pages/Staff";
import Tasks from "@/pages/Tasks";
import CalendarPage from "@/pages/CalendarPage";
import Chat from "@/pages/Chat";
import Whiteboard from "@/pages/Whiteboard";
import Inbox from "@/pages/Inbox";
import Emails from "@/pages/Emails";
import Accounting from "@/pages/Accounting";
import Payroll from "@/pages/Payroll";
import Taxes from "@/pages/Taxes";
import Automation from "@/pages/Automation";
import Admin from "@/pages/Admin";
import HR from "@/pages/HR";
import EmployeeProfile from "@/pages/EmployeeProfile";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordFlow";
import AIAssistant from "@/pages/AIAssistant";
import Analytics from "@/pages/Analytics";
import Projects from "@/pages/Projects";
import Procurement from "@/pages/Procurement";
import Marketing from "@/pages/Marketing";
import Academy from "@/pages/Academy";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="leads" element={<Leads />} />
              <Route path="deals" element={<Deals />} />
              <Route path="tickets" element={<Tickets />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="staff" element={<Staff />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="chat" element={<Chat />} />
              <Route path="whiteboard" element={<Whiteboard />} />
              <Route path="inbox" element={<Inbox />} />
              <Route path="emails" element={<Emails />} />
              <Route path="accounting" element={<Accounting />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="taxes" element={<Taxes />} />
              <Route path="automation" element={<Automation />} />
              <Route path="admin" element={<Admin />} />
              <Route path="hr" element={<HR />} />
              <Route path="employee/:userId" element={<EmployeeProfile />} />
              <Route path="me" element={<EmployeeProfile />} />
              <Route path="ai" element={<AIAssistant />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="projects" element={<Projects />} />
              <Route path="procurement" element={<Procurement />} />
              <Route path="marketing" element={<Marketing />} />
              <Route path="academy" element={<Academy />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
